<template>
  <div class="ls-filter" role="listbox" :aria-label="filterTitle">
    <button type="button"
            class="ls-filter__item"
            :class="{ active: allOption.selected }"
            @click="allOptionClickedHandler"
            role="option"
            :aria-selected="allOption.selected">
      {{ allOption.name }}
    </button>
    <button type="button"
            class="ls-filter__item"
            v-for="(option, index) in filterOptions"
            :key="`tag-filter-option-${index}`"
            :class="{ active: option.selected }"
            @click="optionClickedHandler(option)"
            role="option"
            :aria-selected="option.selected">
      {{ option.name }}
    </button>
  </div>
</template>

<script>
import { computed, reactive } from 'vue';

export default {
  name: 'TagFilter',
  props: {
    options: {
      type: Array,
      required: true,
      validator: (value) => {
        let valid = true;

        for (let i = 0; i < value.length; i += 1) {
          if (
            !Object.prototype.hasOwnProperty.call(value[i], 'name') &&
            !Object.prototype.hasOwnProperty.call(value[i], 'value')
          ) {
            valid = false;
            break;
          }
        }

        return valid;
      },
    },
    filterTitle: {
      type: String,
      required: false,
      default: 'Filter',
    },
  },
  setup(props, { emit }) {
    const filterOptions = reactive(
      props.options.map((option) => ({ ...option, selected: false }))
    );
    const selectedOptions = computed(() =>
      filterOptions.filter((op) => op.selected)
    );
    const allOption = computed(() => ({
      name: 'All',
      value: 'All',
      selected: selectedOptions.value.length === 0,
    }));

    const optionClickedHandler = (option) => {
      option.selected = !option.selected;

      emit('option-clicked', selectedOptions.value);
    };
    const allOptionClickedHandler = () => {
      filterOptions.forEach((option) => {
        option.selected = false;
      });

      emit('option-clicked', selectedOptions.value);
    };

    return {
      allOption,
      allOptionClickedHandler,
      selectedOptions,
      filterOptions,
      optionClickedHandler,
    };
  },
};
</script>
